import { myAxios } from "./axios";

export function getReservations(data, { page, perPage }) {
  let config = {
    params: {
      page,
      perPage,
      ...(data || {}),
    },
  };
  return myAxios.get("/reservations", config);
}

export function getReservation(id) {
  return myAxios.get("/reservations/" + id);
}

export function assignReservation(data) {
  return myAxios.post("/reservations/assign", data);
}

export function deAssignReservation(reservationId, data) {
  return myAxios.post(`/reservations/${reservationId}/deassign`, data);
}

export function cancelReservation(reservationId) {
  return myAxios.delete(`/reservations/${reservationId}/cancel`);
}

export function deAssignCarReservation(carId) {
  return myAxios.post(`/reservations/deassign/cars/${carId}`);
}

export function editReservationAmount(reservationId, data) {
  return myAxios.put(`/reservations/${reservationId}/update`, data);
}
